import styled from "styled-components";
import { RightAlignedCell } from "app/components/React/Table/cells/RankCell";

const PositionCellArrow = styled.div`
    margin: 0 6px;
`;
const PositionCellTarget = styled.b``;
const Container = styled(RightAlignedCell)`
    display: flex;
    text-align: center;
    justify-content: flex-end;
`;
export const PositionChangeCell = ({ row }) => {

    const { PreviousPosition, CurrentPosition } = row;
    const previousValue = PreviousPosition && (Object.values(PreviousPosition)[0] as number);
    const currentValue = CurrentPosition && (Object.values(CurrentPosition)[0] as number);

    if (Number.isInteger(previousValue)) {
        return (
            <Container>
                {previousValue}
                <PositionCellArrow>&#8594;</PositionCellArrow>
                <PositionCellTarget>{currentValue}</PositionCellTarget>
            </Container>
        );
    } else {
        return (
            <Container>
                <PositionCellTarget>{currentValue}</PositionCellTarget>
            </Container>
        );
    }
};
